module.exports = __webpack_public_path__ + "static/img/placeholder.3017929.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/items/thumbnails/placeholder.jpg
// module id = 628
// module chunks = 0